// ! Lembrar de alinhar sempre ao que tem no BACKEND
const DocumentTypeEnums = {
  "NOTA FISCAL": 1,
  BALANCO: 2,
  "REQUISICAO DE ENTRADA": 3,
};

export default DocumentTypeEnums;
